module.exports = __webpack_public_path__ + "static/media/ornament.97053796.svg";